var {
  useMessageFormatter
} = require("@react-aria/i18n");

var {
  filterDOMProps
} = require("@react-aria/utils");

var _babelRuntimeHelpersInteropRequireDefault = $parcel$interopDefault(require("@babel/runtime/helpers/interopRequireDefault"));

var {
  useLink
} = require("@react-aria/link");

var _babelRuntimeHelpersObjectWithoutPropertiesLoose = $parcel$interopDefault(require("@babel/runtime/helpers/objectWithoutPropertiesLoose"));

var _babelRuntimeHelpersExtends = $parcel$interopDefault(require("@babel/runtime/helpers/extends"));

function $parcel$interopDefault(a) {
  return a && a.__esModule ? a.default : a;
}

/**
 * Provides the behavior and accessibility implementation for an in a breadcrumbs component.
 * See `useBreadcrumbs` for details about breadcrumbs.
 */
function useBreadcrumbItem(props, ref) {
  let {
    isCurrent,
    isDisabled,
    'aria-current': ariaCurrent,
    elementType = 'a'
  } = props,
      otherProps = _babelRuntimeHelpersObjectWithoutPropertiesLoose(props, ["isCurrent", "isDisabled", "aria-current", "elementType"]);

  let {
    linkProps
  } = useLink(_babelRuntimeHelpersExtends({
    isDisabled: isDisabled || isCurrent,
    elementType
  }, otherProps), ref);
  let isHeading = /^h[1-6]$/.test(elementType);
  let itemProps = {};

  if (!isHeading) {
    itemProps = linkProps;
  }

  if (isCurrent) {
    itemProps['aria-current'] = ariaCurrent || 'page';
  }

  return {
    itemProps: _babelRuntimeHelpersExtends({
      'aria-disabled': isDisabled
    }, itemProps)
  };
}

exports.useBreadcrumbItem = useBreadcrumbItem;
// ASSET: /Users/govett/dev/react-spectrum-v3/packages/@react-aria/breadcrumbs/intl/ar-AE.json
var $bf7b69514695e7b1128e215173ed3aa$exports = {};
$bf7b69514695e7b1128e215173ed3aa$exports = JSON.parse("{\"breadcrumbs\":\"عناصر الواجهة\"}");
// ASSET: /Users/govett/dev/react-spectrum-v3/packages/@react-aria/breadcrumbs/intl/bg-BG.json
var $b157e8c27c059f2152f74f5070e$exports = {};
$b157e8c27c059f2152f74f5070e$exports = JSON.parse("{\"breadcrumbs\":\"Трохи хляб\"}");
// ASSET: /Users/govett/dev/react-spectrum-v3/packages/@react-aria/breadcrumbs/intl/cs-CZ.json
var $c9bfc59243736e7b1aafaab732ac38b$exports = {};
$c9bfc59243736e7b1aafaab732ac38b$exports = JSON.parse("{\"breadcrumbs\":\"Popis cesty\"}");
// ASSET: /Users/govett/dev/react-spectrum-v3/packages/@react-aria/breadcrumbs/intl/da-DK.json
var $cf8ed6703e35da24c72310112d4e35$exports = {};
$cf8ed6703e35da24c72310112d4e35$exports = JSON.parse("{\"breadcrumbs\":\"Brødkrummer\"}");
// ASSET: /Users/govett/dev/react-spectrum-v3/packages/@react-aria/breadcrumbs/intl/de-DE.json
var $d9307543b0542281beeb7e22f681b19c$exports = {};
$d9307543b0542281beeb7e22f681b19c$exports = JSON.parse("{\"breadcrumbs\":\"Breadcrumbs\"}");
// ASSET: /Users/govett/dev/react-spectrum-v3/packages/@react-aria/breadcrumbs/intl/el-GR.json
var $de142ae801946c567548545107b5531c$exports = {};
$de142ae801946c567548545107b5531c$exports = JSON.parse("{\"breadcrumbs\":\"Πλοηγήσεις breadcrumb\"}");
// ASSET: /Users/govett/dev/react-spectrum-v3/packages/@react-aria/breadcrumbs/intl/en-US.json
var $cc0a6f3770533b578cbd787b234585c8$exports = {};
$cc0a6f3770533b578cbd787b234585c8$exports = JSON.parse("{\"breadcrumbs\":\"Breadcrumbs\"}");
// ASSET: /Users/govett/dev/react-spectrum-v3/packages/@react-aria/breadcrumbs/intl/es-ES.json
var $f70700e533bf9aa56f1f3cd764a1$exports = {};
$f70700e533bf9aa56f1f3cd764a1$exports = JSON.parse("{\"breadcrumbs\":\"Migas de pan\"}");
// ASSET: /Users/govett/dev/react-spectrum-v3/packages/@react-aria/breadcrumbs/intl/et-EE.json
var $ed571b5206ad4b5c094a3c5bdf248c$exports = {};
$ed571b5206ad4b5c094a3c5bdf248c$exports = JSON.parse("{\"breadcrumbs\":\"Lingiread\"}");
// ASSET: /Users/govett/dev/react-spectrum-v3/packages/@react-aria/breadcrumbs/intl/fi-FI.json
var $df9205fadd247c0b84cd79392ce21032$exports = {};
$df9205fadd247c0b84cd79392ce21032$exports = JSON.parse("{\"breadcrumbs\":\"Navigointilinkit\"}");
// ASSET: /Users/govett/dev/react-spectrum-v3/packages/@react-aria/breadcrumbs/intl/fr-FR.json
var $f3eea9c6579603dda934144355040a2d$exports = {};
$f3eea9c6579603dda934144355040a2d$exports = JSON.parse("{\"breadcrumbs\":\"Chemin de navigation\"}");
// ASSET: /Users/govett/dev/react-spectrum-v3/packages/@react-aria/breadcrumbs/intl/he-IL.json
var $f9774d5d142622c7072a1347b897032b$exports = {};
$f9774d5d142622c7072a1347b897032b$exports = JSON.parse("{\"breadcrumbs\":\"שבילי ניווט\"}");
// ASSET: /Users/govett/dev/react-spectrum-v3/packages/@react-aria/breadcrumbs/intl/hr-HR.json
var $a4bbdcc3621c7c584f3572494718a01$exports = {};
$a4bbdcc3621c7c584f3572494718a01$exports = JSON.parse("{\"breadcrumbs\":\"Navigacijski putovi\"}");
// ASSET: /Users/govett/dev/react-spectrum-v3/packages/@react-aria/breadcrumbs/intl/hu-HU.json
var $e12e36b43464d9741af807bada4891$exports = {};
$e12e36b43464d9741af807bada4891$exports = JSON.parse("{\"breadcrumbs\":\"Morzsamenü\"}");
// ASSET: /Users/govett/dev/react-spectrum-v3/packages/@react-aria/breadcrumbs/intl/it-IT.json
var $a79ab94dc8a9c3b2fb085886f5ccbc66$exports = {};
$a79ab94dc8a9c3b2fb085886f5ccbc66$exports = JSON.parse("{\"breadcrumbs\":\"Breadcrumb\"}");
// ASSET: /Users/govett/dev/react-spectrum-v3/packages/@react-aria/breadcrumbs/intl/ja-JP.json
var $baa9ee67056b3cc587d70b0137ab735e$exports = {};
$baa9ee67056b3cc587d70b0137ab735e$exports = JSON.parse("{\"breadcrumbs\":\"パンくずリスト\"}");
// ASSET: /Users/govett/dev/react-spectrum-v3/packages/@react-aria/breadcrumbs/intl/ko-KR.json
var $e40ae400a31373d37c74cdc76c38ff$exports = {};
$e40ae400a31373d37c74cdc76c38ff$exports = JSON.parse("{\"breadcrumbs\":\"탐색 표시\"}");
// ASSET: /Users/govett/dev/react-spectrum-v3/packages/@react-aria/breadcrumbs/intl/lt-LT.json
var $cd039e28de9480e393a928a4b2a2e3b6$exports = {};
$cd039e28de9480e393a928a4b2a2e3b6$exports = JSON.parse("{\"breadcrumbs\":\"Naršymo kelias\"}");
// ASSET: /Users/govett/dev/react-spectrum-v3/packages/@react-aria/breadcrumbs/intl/lv-LV.json
var $c7a1c4d0b73360e4ac4e6ef0c38f0186$exports = {};
$c7a1c4d0b73360e4ac4e6ef0c38f0186$exports = JSON.parse("{\"breadcrumbs\":\"Atpakaļceļi\"}");
// ASSET: /Users/govett/dev/react-spectrum-v3/packages/@react-aria/breadcrumbs/intl/nb-NO.json
var $c64228fcac59603294a5db0d7728ab6d$exports = {};
$c64228fcac59603294a5db0d7728ab6d$exports = JSON.parse("{\"breadcrumbs\":\"Navigasjonsstier\"}");
// ASSET: /Users/govett/dev/react-spectrum-v3/packages/@react-aria/breadcrumbs/intl/nl-NL.json
var $ddafcced542afef86083cfed6bc$exports = {};
$ddafcced542afef86083cfed6bc$exports = JSON.parse("{\"breadcrumbs\":\"Broodkruimels\"}");
// ASSET: /Users/govett/dev/react-spectrum-v3/packages/@react-aria/breadcrumbs/intl/pl-PL.json
var $c61c9a0cad41323b9da26b281e9a5$exports = {};
$c61c9a0cad41323b9da26b281e9a5$exports = JSON.parse("{\"breadcrumbs\":\"Struktura nawigacyjna\"}");
// ASSET: /Users/govett/dev/react-spectrum-v3/packages/@react-aria/breadcrumbs/intl/pt-BR.json
var $e6f79e4771e7984ad4aef9aab4ac6ca3$exports = {};
$e6f79e4771e7984ad4aef9aab4ac6ca3$exports = JSON.parse("{\"breadcrumbs\":\"Caminho detalhado\"}");
// ASSET: /Users/govett/dev/react-spectrum-v3/packages/@react-aria/breadcrumbs/intl/pt-PT.json
var $b1183d1818907354aa5f722f2e42df6b$exports = {};
$b1183d1818907354aa5f722f2e42df6b$exports = JSON.parse("{\"breadcrumbs\":\"Categorias\"}");
// ASSET: /Users/govett/dev/react-spectrum-v3/packages/@react-aria/breadcrumbs/intl/ro-RO.json
var $d745b29ab36c1e9c0ea82baf0e68$exports = {};
$d745b29ab36c1e9c0ea82baf0e68$exports = JSON.parse("{\"breadcrumbs\":\"Miez de pâine\"}");
// ASSET: /Users/govett/dev/react-spectrum-v3/packages/@react-aria/breadcrumbs/intl/ru-RU.json
var $b7d77b5123f4c62cd57ce0b9e97ac16f$exports = {};
$b7d77b5123f4c62cd57ce0b9e97ac16f$exports = JSON.parse("{\"breadcrumbs\":\"Навигация\"}");
// ASSET: /Users/govett/dev/react-spectrum-v3/packages/@react-aria/breadcrumbs/intl/sk-SK.json
var $fd8955145330da5f2c0105b59ad5fc2$exports = {};
$fd8955145330da5f2c0105b59ad5fc2$exports = JSON.parse("{\"breadcrumbs\":\"Navigačné prvky Breadcrumbs\"}");
// ASSET: /Users/govett/dev/react-spectrum-v3/packages/@react-aria/breadcrumbs/intl/sl-SI.json
var $bc0bb761287ea640b58f23e5ac6$exports = {};
$bc0bb761287ea640b58f23e5ac6$exports = JSON.parse("{\"breadcrumbs\":\"Drobtine\"}");
// ASSET: /Users/govett/dev/react-spectrum-v3/packages/@react-aria/breadcrumbs/intl/sr-SP.json
var $e3f3030a1001072abe2a2fc4d7d3fc6$exports = {};
$e3f3030a1001072abe2a2fc4d7d3fc6$exports = JSON.parse("{\"breadcrumbs\":\"Putanje navigacije\"}");
// ASSET: /Users/govett/dev/react-spectrum-v3/packages/@react-aria/breadcrumbs/intl/sv-SE.json
var $db2dad9348ef6cca1e175dcd$exports = {};
$db2dad9348ef6cca1e175dcd$exports = JSON.parse("{\"breadcrumbs\":\"Sökvägar\"}");
// ASSET: /Users/govett/dev/react-spectrum-v3/packages/@react-aria/breadcrumbs/intl/tr-TR.json
var $ba7cb8ac4472c4c35403d5690af169ed$exports = {};
$ba7cb8ac4472c4c35403d5690af169ed$exports = JSON.parse("{\"breadcrumbs\":\"İçerik haritaları\"}");
// ASSET: /Users/govett/dev/react-spectrum-v3/packages/@react-aria/breadcrumbs/intl/uk-UA.json
var $edae15106a0d59ca331efc75aa5b07$exports = {};
$edae15106a0d59ca331efc75aa5b07$exports = JSON.parse("{\"breadcrumbs\":\"Навігаційна стежка\"}");
// ASSET: /Users/govett/dev/react-spectrum-v3/packages/@react-aria/breadcrumbs/intl/zh-CN.json
var $e534b66681c746bca8bec9ceeaaffea9$exports = {};
$e534b66681c746bca8bec9ceeaaffea9$exports = JSON.parse("{\"breadcrumbs\":\"导航栏\"}");
// ASSET: /Users/govett/dev/react-spectrum-v3/packages/@react-aria/breadcrumbs/intl/zh-TW.json
var $e95dae7ac0c049a67eea7b1ff53cd4e$exports = {};
$e95dae7ac0c049a67eea7b1ff53cd4e$exports = JSON.parse("{\"breadcrumbs\":\"導覽列\"}");
// @ts-ignore
const $a3b7b8d70b74efa641c5c2c503b27e81$var$intlMessages = {
  "ar-AE": _babelRuntimeHelpersInteropRequireDefault($bf7b69514695e7b1128e215173ed3aa$exports).default,
  "bg-BG": _babelRuntimeHelpersInteropRequireDefault($b157e8c27c059f2152f74f5070e$exports).default,
  "cs-CZ": _babelRuntimeHelpersInteropRequireDefault($c9bfc59243736e7b1aafaab732ac38b$exports).default,
  "da-DK": _babelRuntimeHelpersInteropRequireDefault($cf8ed6703e35da24c72310112d4e35$exports).default,
  "de-DE": _babelRuntimeHelpersInteropRequireDefault($d9307543b0542281beeb7e22f681b19c$exports).default,
  "el-GR": _babelRuntimeHelpersInteropRequireDefault($de142ae801946c567548545107b5531c$exports).default,
  "en-US": _babelRuntimeHelpersInteropRequireDefault($cc0a6f3770533b578cbd787b234585c8$exports).default,
  "es-ES": _babelRuntimeHelpersInteropRequireDefault($f70700e533bf9aa56f1f3cd764a1$exports).default,
  "et-EE": _babelRuntimeHelpersInteropRequireDefault($ed571b5206ad4b5c094a3c5bdf248c$exports).default,
  "fi-FI": _babelRuntimeHelpersInteropRequireDefault($df9205fadd247c0b84cd79392ce21032$exports).default,
  "fr-FR": _babelRuntimeHelpersInteropRequireDefault($f3eea9c6579603dda934144355040a2d$exports).default,
  "he-IL": _babelRuntimeHelpersInteropRequireDefault($f9774d5d142622c7072a1347b897032b$exports).default,
  "hr-HR": _babelRuntimeHelpersInteropRequireDefault($a4bbdcc3621c7c584f3572494718a01$exports).default,
  "hu-HU": _babelRuntimeHelpersInteropRequireDefault($e12e36b43464d9741af807bada4891$exports).default,
  "it-IT": _babelRuntimeHelpersInteropRequireDefault($a79ab94dc8a9c3b2fb085886f5ccbc66$exports).default,
  "ja-JP": _babelRuntimeHelpersInteropRequireDefault($baa9ee67056b3cc587d70b0137ab735e$exports).default,
  "ko-KR": _babelRuntimeHelpersInteropRequireDefault($e40ae400a31373d37c74cdc76c38ff$exports).default,
  "lt-LT": _babelRuntimeHelpersInteropRequireDefault($cd039e28de9480e393a928a4b2a2e3b6$exports).default,
  "lv-LV": _babelRuntimeHelpersInteropRequireDefault($c7a1c4d0b73360e4ac4e6ef0c38f0186$exports).default,
  "nb-NO": _babelRuntimeHelpersInteropRequireDefault($c64228fcac59603294a5db0d7728ab6d$exports).default,
  "nl-NL": _babelRuntimeHelpersInteropRequireDefault($ddafcced542afef86083cfed6bc$exports).default,
  "pl-PL": _babelRuntimeHelpersInteropRequireDefault($c61c9a0cad41323b9da26b281e9a5$exports).default,
  "pt-BR": _babelRuntimeHelpersInteropRequireDefault($e6f79e4771e7984ad4aef9aab4ac6ca3$exports).default,
  "pt-PT": _babelRuntimeHelpersInteropRequireDefault($b1183d1818907354aa5f722f2e42df6b$exports).default,
  "ro-RO": _babelRuntimeHelpersInteropRequireDefault($d745b29ab36c1e9c0ea82baf0e68$exports).default,
  "ru-RU": _babelRuntimeHelpersInteropRequireDefault($b7d77b5123f4c62cd57ce0b9e97ac16f$exports).default,
  "sk-SK": _babelRuntimeHelpersInteropRequireDefault($fd8955145330da5f2c0105b59ad5fc2$exports).default,
  "sl-SI": _babelRuntimeHelpersInteropRequireDefault($bc0bb761287ea640b58f23e5ac6$exports).default,
  "sr-SP": _babelRuntimeHelpersInteropRequireDefault($e3f3030a1001072abe2a2fc4d7d3fc6$exports).default,
  "sv-SE": _babelRuntimeHelpersInteropRequireDefault($db2dad9348ef6cca1e175dcd$exports).default,
  "tr-TR": _babelRuntimeHelpersInteropRequireDefault($ba7cb8ac4472c4c35403d5690af169ed$exports).default,
  "uk-UA": _babelRuntimeHelpersInteropRequireDefault($edae15106a0d59ca331efc75aa5b07$exports).default,
  "zh-CN": _babelRuntimeHelpersInteropRequireDefault($e534b66681c746bca8bec9ceeaaffea9$exports).default,
  "zh-TW": _babelRuntimeHelpersInteropRequireDefault($e95dae7ac0c049a67eea7b1ff53cd4e$exports).default
};

/**
 * Provides the behavior and accessibility implementation for a breadcrumbs component.
 * Breadcrumbs display a heirarchy of links to the current page or resource in an application.
 */
function useBreadcrumbs(props) {
  let {
    'aria-label': ariaLabel
  } = props,
      otherProps = _babelRuntimeHelpersObjectWithoutPropertiesLoose(props, ["aria-label"]);

  let formatMessage = useMessageFormatter($a3b7b8d70b74efa641c5c2c503b27e81$var$intlMessages);
  return {
    navProps: _babelRuntimeHelpersExtends({}, filterDOMProps(otherProps, {
      labelable: true
    }), {
      'aria-label': ariaLabel || formatMessage('breadcrumbs')
    })
  };
}

exports.useBreadcrumbs = useBreadcrumbs;
